import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';

import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { defaultNavigationOptions } from '../../../entities/navigation/navigation-options.entity';

import { RecordSandboxService } from '../../sandbox/record-sandbox.service';

@Injectable()
export class RecordResolverService {
    constructor(
        private router: Router,
        private readonly sandbox: RecordSandboxService
    ) {}

    resolve(route: ActivatedRouteSnapshot): Observable<any> {
        const recordId = route.params.recordId;
        const queryParams = route.queryParams;
        return this.sandbox.navigateById(recordId, { ...defaultNavigationOptions, queryParams }).pipe(
            tap(isNavigationSuccesfull => {
                if (!isNavigationSuccesfull) {
                    this.navigateToDashboard();
                    this.showNavigationFailedToast();
                }
            })
        );
    }

    private navigateToDashboard(): void {
        this.router.navigate(['/']);
    }

    private showNavigationFailedToast(): void {
        this.sandbox.addWarning('reference-code.errors.could-not-navigate');
    }
}
